module.exports = __webpack_public_path__ + "img/PoonehGhana_StVincent_1.aa177780.jpg";